import { DateTime } from 'luxon';
import { getI18n } from 'react-i18next';

export const WebinarDate = ({ date: dateString }: { date: string | null | undefined }) => {
    if (!dateString) {
        return <></>;
    }

    const date = DateTime.fromISO(dateString).toLocal().setLocale(getI18n().language);
    return (
        <strong>
            {date.toFormat('ccc, ')}
            {date.toLocaleString(DateTime.DATE_FULL)}
            <span> at </span>
            {date.toLocaleString(DateTime.TIME_SIMPLE)}
        </strong>
    );
};
